import { render, staticRenderFns } from "./yazyjsxy.vue?vue&type=template&id=8a8bb6bc&scoped=true&"
import script from "./yazyjsxy.vue?vue&type=script&lang=js&"
export * from "./yazyjsxy.vue?vue&type=script&lang=js&"
import style0 from "./yazyjsxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./yazyjsxy.vue?vue&type=style&index=1&id=8a8bb6bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8bb6bc",
  null
  
)

export default component.exports